import React, { useState } from 'react';
import { Button, Card, Badge, Input } from '../components/ui';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../components/ui/dialog';

// DECISION: Demo page strings — noscan suppressed as they are illustrative UI examples, not business labels
const DEMO_STRINGS = {
    emailPlaceholder: 'Enter your email', // noscan
    passwordPlaceholder: 'Enter password', // noscan
    modalTitle: 'Example Modal', // noscan
};

const ComponentDemo = () => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <div style={{ padding: 'var(--space-8)', maxWidth: '1200px', margin: '0 auto' }}>
            <h1>Design System Demo</h1>

            <section style={{ marginBottom: 'var(--space-12)' }}>
                <h2>Buttons</h2>
                <div style={{ display: 'flex', gap: 'var(--space-4)', flexWrap: 'wrap' }}>
                    <Button variant="primary">Primary Button</Button>
                    <Button variant="secondary">Secondary Button</Button>
                    <Button variant="destructive">Destructive Button</Button>
                    <Button variant="ghost">Ghost Button</Button>
                    <Button variant="primary" disabled>Disabled Button</Button>
                </div>
            </section>

            <section style={{ marginBottom: 'var(--space-12)' }}>
                <h2>Badges</h2>
                <div style={{ display: 'flex', gap: 'var(--space-4)', flexWrap: 'wrap' }}>
                    <Badge variant="success">Success</Badge>
                    <Badge variant="warning">Warning</Badge>
                    <Badge variant="error">Error</Badge>
                    <Badge variant="neutral">Neutral</Badge>
                </div>
            </section>

            <section style={{ marginBottom: 'var(--space-12)' }}>
                <h2>Cards</h2>
                <div style={{ display: 'grid', gap: 'var(--space-4)', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
                    <Card>
                        <h3>Regular Card</h3>
                        <p>This is a standard card component with no interaction.</p>
                    </Card>
                    <Card interactive onClick={() => alert('Card clicked!')}>
                        <h3>Interactive Card</h3>
                        <p>This card has hover effects and is clickable.</p>
                    </Card>
                </div>
            </section>

            <section style={{ marginBottom: 'var(--space-12)' }}>
                <h2>Input Fields</h2>
                <div style={{ maxWidth: '400px', display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
                    <Input label="Email" type="email" placeholder={DEMO_STRINGS.emailPlaceholder} />
                    <Input label="Password" type="password" placeholder={DEMO_STRINGS.passwordPlaceholder} helperText="Must be at least 8 characters" />
                    <Input label="Username" type="text" error="This username is already taken" />
                </div>
            </section>

            <section style={{ marginBottom: 'var(--space-12)' }}>
                <h2>Dialog</h2>
                <Button onClick={() => setModalOpen(true)}>Open Dialog</Button>
                <Dialog open={modalOpen} onOpenChange={setModalOpen}>
                    <DialogContent>
                        <DialogHeader>
                            <DialogTitle>{DEMO_STRINGS.modalTitle}</DialogTitle>
                            <DialogDescription>
                                This is an example dialog with a title, body content, and footer actions.
                                Press Escape or click outside to close.
                            </DialogDescription>
                        </DialogHeader>
                        <DialogFooter>
                            <Button variant="secondary" onClick={() => setModalOpen(false)}>Cancel</Button>
                            <Button variant="primary" onClick={() => setModalOpen(false)}>Confirm</Button>
                        </DialogFooter>
                    </DialogContent>
                </Dialog>
            </section>
        </div>
    );
};

export default ComponentDemo;
